interface Props {
  className?: string;
}

export const RavenIcon = ({ className }: Props) => (
  <div className={className}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M91.96 53.85C91.96 53.85 88.8 49.75 84.96 48.77C84.6 48.51 84.14 48.24 83.57 48.04C81.75 47.4 80.09 47.93 79.47 48.17L71.02 51.27C72.05 48.38 76.53 44.2 76.53 44.2C81.07 41.01 78.16 36.87 78.16 36.87C77.82 35.25 60.2 25.87 60.2 25.87C68.71 40.64 58.9 46.56 58.9 46.56C59.11 29.12 51.23 25.91 51.23 25.91C50.63 24 0.0499878 0.179993 0.0499878 0.179993C1.72999 4.26999 18.32 17.35 18.32 17.35C19.26 20.1 22.41 21.21 22.41 21.21C26.73 26.7 32.66 28.64 32.66 28.64C32.84 31.5 36.9 35.92 36.9 35.92C40.2 51.53 44.62 55.35 44.62 55.35C44.49 57.27 44.37 59.19 44.24 61.11C44.59 64.1 42.27 68.61 30.14 75.16C25.83 79.27 21.52 83.38 17.21 87.49C17.21 87.49 25.54 82.57 38.84 77.71C54.86 71.86 57.32 76.31 65.44 70.42C74.81 63.63 77.53 61.18 81.58 61.31C82.25 61.33 83.93 61.47 86.13 60.98C87.67 60.63 88.86 60.1 89.58 59.74C90.97 59.47 95.78 58.7 98.91 61.58C99.23 61.88 99.56 62.23 99.86 62.64C99.86 62.64 101.37 57.09 91.96 53.86V53.85ZM88.55 54.31C88.43 54.7 88.02 54.85 87.68 54.97C86.88 55.26 85.32 55.44 84.87 54.57C84.64 54.12 84.77 53.5 85.07 53.1C85.1 53.06 85.53 52.49 86.18 52.5C86.37 52.5 86.49 52.55 86.95 52.75C87.29 52.9 87.7 53.08 88.17 53.28C88.21 53.32 88.69 53.81 88.54 54.31H88.55Z"
        fill="white"
      />
    </svg>
  </div>
);
